import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Modal Footer Buttons --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalFooterButtons.';
  public static readonly close = `${Id.prefix}close`;
}

export class LangModalFooterButtons {
  private constructor() {}
  public static close(): string {
    return interpolate(Id.close);
  }
}

export class ModalFooterButtonsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.close, 'Close', 'Button: close');
  }
}
